import { render, staticRenderFns } from "./AddSub.vue?vue&type=template&id=d95534d8&lang=pug&"
import script from "./AddSub.vue?vue&type=script&lang=js&"
export * from "./AddSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports